import { render, staticRenderFns } from "./sfc-menu-slim-v2.vue?vue&type=template&id=7200150d&scoped=true&lang=pug&"
import script from "./sfc-menu-slim-v2.vue?vue&type=script&lang=js&"
export * from "./sfc-menu-slim-v2.vue?vue&type=script&lang=js&"
import style0 from "./sfc-menu-slim-v2.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./sfc-menu-slim-v2.vue?vue&type=style&index=1&id=7200150d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7200150d",
  null
  
)

export default component.exports